import MemoryModel from "../model/memory";
import { fetchMemories } from "../provider/api";

export async function getMemories(): Promise<{ events: MemoryModel[] }> {
    try {
        const responseData = await fetchMemories();

        const items = responseData.data.map((item: any) => {
            const attributes = item.attributes;

            
            const fotoData = attributes.foto?.data?.attributes.url || null;
            

            return new MemoryModel(
                item.id,
                attributes.titulo,
                attributes.descricao,
                attributes.sub_titulo,
                attributes.createdAt,
                attributes.updatedAt,
                attributes.publishedAt,
                fotoData 
            );
        });

        return { events: items };

    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar memorias`);
        console.log(error.toString());
        return { events: [] };
    }
}
